import { FC, useEffect } from 'react';
import SurveyDefaultStep from '../SurveyDefaultStep';
import LockImage from '@/assets/images/lock.png';
import useSurveyNavigate from '@/hooks/useSurveyNavigate';
import analytics from '@/utils/analytics/analyticsInstance';

const CreateAccountStep: FC = () => {
  const { next } = useSurveyNavigate();

  useEffect(() => {
    analytics.track('webOnboardingScreenOpened', {
      screen_title: 'Create your account to unlock it all',
    });
  }, []);

  return (
    <SurveyDefaultStep
      title={{ value: 'Create your account to unlock it all' }}
      subTitle={{ value: 'Access your personalized feed — and start growing your rewards faster' }}
      image={LockImage}
      button={{ onClick: next }}
    />
  );
};

export default CreateAccountStep;
